import moment from "moment";

export function subtractOneWorkingDayIndia(date) {
    // Parse the date into a moment object
    let currentDate = moment(date);

    // Subtract one day
    currentDate.subtract(1, "days");

    // If the resulting day is Sunday (0), keep subtracting until it's a working day
    while (currentDate.day() === 0) {
        currentDate.subtract(1, "days");
    }

    return currentDate.format("YYYY-MM-DD");
}

export function extractNumberBeforeYearFromTC(input) {
  // Get last 2 digits of the current year
  const currentYearLast2 = new Date().getFullYear().toString().slice(-2);

  // Get digits after 'TC' only
  const numericString = input.slice(2).match(/\d+/g)?.join('') ?? '';

  // Find index of the current year part
  const index = numericString.indexOf(currentYearLast2);

  // Get substring before that
  const result = index !== -1 ? numericString.slice(0, index) : numericString;

  return result;
}
